import Vue from "vue";
import App from "./App";
import router from "./router";
import editor from "@tinymce/tinymce-vue";
import CoreuiVue from "@coreui/vue";
import "./main.css";
import { iconsSet as icons } from "./assets/icons/icons.js";
import { i18n } from "./plugins/i18n";
import VueCookies from "vue-cookies";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import VueMoment from "vue-moment";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import ToggleButton from "vue-js-toggle-button";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import VueEllipseProgress from "vue-ellipse-progress";
import { ColorPicker, ColorPanel } from "one-colorpicker";

import dotenv from "dotenv";
dotenv.config();

const moment = require("moment");
require("moment/locale/th");
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "tinymce/tinymce";

// Theme
import "tinymce/themes/silver/theme";

// Skins
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

// Plugins
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";

import "babel-polyfill";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings as LuxonSettings } from "luxon";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

//Icon
import { library } from "@fortawesome/fontawesome-svg-core";
import {
   faEyeSlash,
   faPowerOff,
   faUser,
   faStore,
   faBullhorn,
   faSearch,
   faFileUpload,
   faFilter,
   faSortDown,
   faPencilAlt,
   faTrashAlt,
   faTimes,
   faTimesCircle,
   faFileDownload,
   faEye,
   faBarcode,
   faPlus,
   faMinus,
   faStar,
   faChevronLeft,
   faChevronRight,
   faChevronDown,
   faChevronUp,
   faHome,
   faBuilding,
   faHotel,
   faCircle,
   faArrowRight,
   faClipboard,
   faBox,
   faSort,
   faHandHoldingUsd,
   faPlusCircle,
   faCheckCircle,
   faExclamationCircle,
   faEllipsisV,
   faCheck,
   faMapMarkerAlt,
   faMapMarkedAlt,
   faStickyNote,
   faShippingFast,
   faMoneyBillWave,
   faReceipt,
   faUserCheck,
   faUserPlus,
   faPercent,
   faRobot,
   faFileExport,
   faUserFriends,
   faCommentAlt,
   faSmile,
   faAngry,
   faMobileAlt,
   faWindowMaximize,
   faMap,
   faImage,
   faSave,
   faPlusSquare,
   faAlignJustify,
   faAlignLeft,
   faAlignRight,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarFar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
   fab,
   faFacebookF,
   faInstagram,
   faLine,
   faTwitter,
   faApple,
   faYoutube,
} from "@fortawesome/free-brands-svg-icons";
library.add(
   fab,
   faFacebookF,
   faInstagram,
   faLine,
   faTwitter,
   faApple,
   faYoutube
);
library.add(
   faEyeSlash,
   faUser,
   faPowerOff,
   faStore,
   faBullhorn,
   faSearch,
   faFilter,
   faFileUpload,
   faSortDown,
   faPencilAlt,
   faTrashAlt,
   faTimes,
   faTimesCircle,
   faFileDownload,
   faEye,
   faBarcode,
   faPlus,
   faMinus,
   faStar,
   faStarFar,
   faChevronLeft,
   faChevronRight,
   faChevronDown,
   faChevronUp,
   faHome,
   faBuilding,
   faHotel,
   faCircle,
   faArrowRight,
   faClipboard,
   faBox,
   faSort,
   faHandHoldingUsd,
   faPlusCircle,
   faCheckCircle,
   faExclamationCircle,
   faEllipsisV,
   faCheck,
   faMapMarkerAlt,
   faMapMarkedAlt,
   faStickyNote,
   faShippingFast,
   faMoneyBillWave,
   faReceipt,
   faUserCheck,
   faUserPlus,
   faPercent,
   faRobot,
   faFileExport,
   faUserFriends,
   faCommentAlt,
   faSmile,
   faAngry,
   faMobileAlt,
   faWindowMaximize,
   faMap,
   faImage,
   faSave,
   faPlusSquare,
   faAlignJustify,
   faAlignLeft,
   faAlignRight
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueEllipseProgress);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(VueAxios, axios);
Vue.use(vueNumeralFilterInstaller, { locale: "en-gb" });
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(ColorPanel);
Vue.use(ColorPicker);

Vue.use(ToggleButton);
Vue.use(Vuelidate);
import VueSlickCarousel from "vue-slick-carousel";
const Slick = {
   install(Vue) {
      Vue.component("slick", VueSlickCarousel);
   },
};

Vue.use(Slick);
Vue.use(VueMoment, {
   moment,
});
Vue.component("datetime", Datetime);
Vue.component("editor", editor);

let globalData = new Vue({
   data: {
      $isLoading: false,
      $campaignName: "",
   },
});

Vue.mixin({
   computed: {
      $isLoading: {
         get: function() {
            return globalData.$data.$isLoading;
         },
         set: function(isLoading) {
            globalData.$data.$isLoading = isLoading;
         },
      },
   },
});

// Choose MODE (INHOME, DEV , PROD )
const MODE = process.env.VUE_APP_MODE ? `${process.env.VUE_APP_MODE}` : "DEV";
if (MODE == "PROD") {
   Vue.prototype.$baseUrl = "https://skl-admin-api.skl.co.th/api";
}

if (MODE == "DEV") {
   Vue.prototype.$baseUrl = "https://dev-skl-admin-api.dosetech.co/api";
}

Vue.prototype.$formatDate = "DD MMM YYYY";
Vue.prototype.$formatDateTime = "DD MMM YYYY (HH:mm)";
Vue.prototype.$formatTime = "HH:mm";

// API request
Vue.axios.interceptors.request.use(function(config) {
   config.headers.Authorization = Vue.$cookies.isKey("admin-token")
      ? `Bearer ${Vue.$cookies.get("admin-token")}`
      : "null";

   config.headers.BrandID =
      store.getters.getCurrentBrandID() == null
         ? 0
         : store.getters.getCurrentBrandID();
   return config;
});
// API response
Vue.axios.interceptors.response.use(
   function(response) {
      return Promise.resolve(response.data);
   },
   function(error) {
      if (error.response.status == 401) {
         Vue.$cookies.remove("admin-token");
         window.location.href = "/login";
      }
      return Promise.reject(error);
   }
);

LuxonSettings.defaultLocale = "th";

router.beforeEach((to, from, next) => {
   if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!VueCookies.get("admin-token")) {
         next({
            path: "/login",
         });
      } else {
         if (!to.query.brandID) {
            if (from.query.brandID) {
               if (to.params.id) {
                  next({
                     name: to.name,
                     query: { brandID: from.query.brandID, ...to.query },
                     params: { id: to.params.id, ...to.params },
                  });
               } else {
                  next({
                     name: to.name,
                     query: { brandID: from.query.brandID, ...to.query },
                  });
               }
               return;
            } else {
               next();
            }
         } else {
            next();
         }
      }
   } else if (to.matched.some((record) => record.meta.requiresIsLogin)) {
      if (VueCookies.get("admin-token")) {
         next({
            path: "/",
         });
      } else {
         next();
      }
   } else {
      next();
   }
});

new Vue({
   el: "#app",
   library,
   i18n,
   router,
   icons,
   store,
   template: "<App/>",
   components: {
      App,
   },
});
